module.exports = __webpack_public_path__ + "img/pic_kanta.6f07b5b9.gif";